import { render, staticRenderFns } from "./ConfirmDrugDelivery.vue?vue&type=template&id=24fce578&"
import script from "./ConfirmDrugDelivery.vue?vue&type=script&lang=js&"
export * from "./ConfirmDrugDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDrugDelivery.vue?vue&type=style&index=0&id=24fce578&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports